module.exports = __webpack_public_path__ + "fonts/TT_Commons_Pro_500_Bold.b5b9d0e.woff";